import { environment } from '../../../../environments/environment';

/** `environment.baseUrl` + `environment.apiPrefix` + `path`. */
export function buildApiUrl(path: string): string {
  return apiBaseUrl() + (path.startsWith('/') ? path : `/${path}`);
}

/** Origem + prefixo da API, sem barra no fim. */
export function apiBaseUrl(): string {
  const origin = environment.baseUrl?.trim().replace(/\/+$/, '') ?? '';
  const prefix = environment.apiPrefix?.trim().replace(/^\/+|\/+$/g, '') ?? '';

  return [origin, prefix].filter((segmento) => segmento.length > 0).join('/');
}
